import React from 'react';
import CalendarContextType from '../types/CalendarContext';

const CalendarContext = React.createContext<CalendarContextType | null>(null);

export default CalendarContext;
